<template>
  <div class="hamburger js-hamburger" :class="{ 'is-active': active }">
    <div class="hamburger-box">
      <div class="hamburger-inner bg-brand"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: Boolean
  }
};
</script>

<style scoped>
.hamburger {
  @apply inline-block overflow-visible m-0 cursor-pointer ease-linear border-0 bg-transparent;
}
/* font: inherit;
  padding: 15px;
  transition-duration: 0.15s;
  transition-property: opacity, filter;
  text-transform: none;
  color: inherit; */

.hamburger.is-active:hover,
.hamburger:hover {
  @apply opacity-70;
}

.hamburger.is-active .hamburger-inner,
.hamburger.is-active .hamburger-inner:after,
.hamburger.is-active .hamburger-inner:before {
  @apply bg-current;
}

.hamburger-box {
  @apply relative inline-block w-10 h-6;
}

.hamburger-inner {
  @apply top-1/2 block duration-75;
  margin-top: -2px;
  transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.hamburger-inner,
.hamburger-inner:after,
.hamburger-inner:before {
  @apply absolute w-10 h-1 ease-linear transition-transform bg-current rounded-lg;
}

.hamburger-inner:after,
.hamburger-inner:before {
  @apply block;
  content: "";
}

.hamburger-inner:before {
  top: -10px;
  transition: top 75ms ease 0.12s, opacity 75ms ease;
}

.hamburger-inner:after {
  bottom: -10px;
  transition: bottom 75ms ease 0.12s,
    transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19);
}
/*  */
.is-active .hamburger-inner {
  transition-delay: 0.12s;
  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  transform: rotate(45deg);
}

.is-active .hamburger-inner:before {
  top: 0;
  transition: top 75ms ease, opacity 75ms ease 0.12s;
  opacity: 0;
}

.is-active .hamburger-inner:after {
  bottom: 0;
  transition: bottom 75ms ease,
    transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  transform: rotate(-90deg);
}
</style>
